import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=763ff99c&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=763ff99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ff99c",
  null
  
)

export default component.exports